import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../../../constants/cypressIds';
import { hideModal } from '../../../../../../../../../../redux/modules/modal';
import FormInput from '../../../../../../../../../form/FormInput';

const EditQuestionCategoryNameModal = ({ questionCategory, editCategory }) => {
  const dispatch = useDispatch();

  const useFormMethods = useForm({ defaultValues: { name: questionCategory.name } });

  const { handleSubmit } = useFormMethods;

  const onSubmit = async data => {
    editCategory({ questionCategoryId: questionCategory.id, name: data.name });
  };

  return (
    <Box>
      <Text mb={8} textStyle="bodyXxl500">Edit Question Category Name</Text>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormInput
          required
          cypressId={CypressIds.reqTemplatesEditQuestionCategoryNameInput}
          inputName="name"
          labelName="Category Name"
          placeholder="Category Name"
          useFormMethods={useFormMethods}
        />

        <HStack justifyContent="center">
          <Button
            data-cy={CypressIds.editQuestionCategoryCancelButton}
            variant="secondary"
            onClick={() => dispatch(hideModal())}
          >
            Cancel
          </Button>

          <Button data-cy={CypressIds.editQuestionCategorySaveButton} type="submit">
            Save Changes
          </Button>
        </HStack>
      </form>
    </Box>
  );
};

EditQuestionCategoryNameModal.propTypes = { questionCategory: PropTypes.object.isRequired, editCategory: PropTypes.func.isRequired };

export default EditQuestionCategoryNameModal;
